export class HttpError extends Error {
    constructor(statusCode, message) {
        super(message);
        this.name = this.constructor.name;
        this.statusCode = statusCode;
    }
}
export class ApiError extends HttpError {
    constructor(status, message, code) {
        super(status, message);
        this.name = this.constructor.name;
        this.code = code;
        this.violations = null;
    }
    addViolations(violations) {
        this.violations = violations;
        return this;
    }
}
export class UPHttpError extends Error {
    constructor(statusCode, message, values) {
        super(parseErrorMessage(message, values));
        this.name = this.constructor.name;
        this.statusCode = statusCode;
        this.values = values;
    }
}
export class UPApiError extends UPHttpError {
    constructor(status, message, values, code) {
        super(status, message, values);
        this.name = this.constructor.name;
        this.code = code;
    }
}
function parseErrorMessage(message, values) {
    const keys = Object.keys(values);
    if (!keys.length)
        return message;
    return keys.reduce((acc, key) => acc.replace(new RegExp(`<${key}>`, 'g'), values[key]), message);
}
